export default "__VITE_ASSET__DQ_ai_An__"